import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const CardRoot = styled('article', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    overflow: 'hidden',
    border: '1.5px solid transparent',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.18)',
    transition:
      'transform {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-3px)',
      boxShadow: '0 20px 40px -16px rgba(128, 84, 255, 0.32)',
    },
  },
})

const ImageWrapper = styled(Link, {
  base: {
    position: 'relative',
    aspectRatio: '16 / 9',
    overflow: 'hidden',
    backgroundColor: '#F1ECFF',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'block',
  },
})

const ImageElement = styled('img', {
  base: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
})

const ImagePlaceholder = styled('div', {
  base: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '40px',
    color: 'quickpass.primary',
    opacity: '0.6',
  },
})

const BadgeRow = styled('div', {
  base: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    right: '12px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '8px',
    pointerEvents: 'none',
  },
})

const StatusBadge = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '24px',
    paddingX: '10px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    pointerEvents: 'auto',
  },
  variants: {
    tone: {
      available: { backgroundColor: '#D7F5E1', color: '#10663A' },
      'available-soon': { backgroundColor: '#FFF1CC', color: '#7A5300' },
      occupied: { backgroundColor: '#FFE3DD', color: '#8B1E2C' },
      unavailable: { backgroundColor: '#E5E0F5', color: '#4F4666' },
    },
  },
})

const SaveButton = styled('button', {
  base: {
    pointerEvents: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.primary',
    fontSize: '18px',
    cursor: 'pointer',
    boxShadow: '0 6px 14px -6px rgba(0, 0, 0, 0.2)',
    transition:
      'transform {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'scale(1.08)',
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.6',
    },
  },
  variants: {
    isSaved: {
      true: {
        backgroundColor: 'quickpass.primary',
        color: '#FFFFFF',
      },
    },
  },
})

const Body = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '14px 16px 16px 16px',
  },
})

const TitleRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
})

const Title = styled(Link, {
  base: {
    fontFamily: 'display',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
    letterSpacing: '-0.3px',
    textDecoration: 'none',
    overflow: 'hidden',
    lineClamp: '1',
    _hover: {
      color: 'quickpass.primary',
    },
  },
})

const Address = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const Price = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.primary',
    margin: '6px 0 0 0',
    letterSpacing: '-0.3px',
  },
})

const Meta = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const Footer = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    marginTop: '4px',
  },
})

const MoveInLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
  },
})

const ManagedBy = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    opacity: '0.85',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '50%',
  },
})

export {
  CardRoot,
  ImageWrapper,
  ImageElement,
  ImagePlaceholder,
  BadgeRow,
  StatusBadge,
  SaveButton,
  Body,
  TitleRow,
  Title,
  Address,
  Price,
  Meta,
  Footer,
  MoveInLabel,
  ManagedBy,
}
